import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDateTime2, formatDisplayDateTime4, removeTime } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'

export const mulAcctReceiptAjaxMixin = {
  data() {
    return {
    }
  },
  created() {
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  methods: {
    async performSearchMultAcctRcpt() {
      const apiUrl = this.$store.state.receipt.menu.performSearchMultiAcct
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.mulAcctRcptFilterForm)

          if (messageFilters.transactionDateFrom !== null && messageFilters.transactionDateFrom !== '') {
            messageFilters.transactionDateFrom = formatDisplayDateTime2(removeTime(messageFilters.transactionDateFrom))
          }

          if (messageFilters.transactionDateTo !== null && messageFilters.transactionDateTo !== '') {
            messageFilters.transactionDateTo = formatDisplayDateTime2(removeTime(messageFilters.transactionDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, paramMap), messageFilters, this.pagination.sortBy, this.pagination.sortDesc))
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((result) => {
              const resultList = {
                branch: result.branch,
                acctNo: result.acctNo,
                docNo: result.docNo,
                suffix: result.suffix,
                fund: result.fund,
                type: result.type,
                tranDate: this.formatDate(result.tranDate),
                currency: result.curr,
                amount: formatPrice(result.debitAmt),
                gst: formatPrice(result.othGST),
                bankOrigAmt: formatPrice(result.bankOrigAmt),
                bankLocTot: formatPrice(result.bankLocTotal)
              }
              this.items.push(resultList)
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    async performReviewMultAcctRcpt() {
      const apiURI = this.$store.state.receipt.menu.performActionMultiAcct
      if (apiURI) {
        try {
          this.mulAcctRcptForm.actionName = 'MULTIPLE_RECEIPT_REVIEW'
          this.mulAcctRcptForm.branch = this.receiptData.branch
          this.mulAcctRcptForm.transactionType = this.receiptData.type
          this.mulAcctRcptForm.documentNo = this.receiptData.docNo
          const result = await this.$http.post(apiURI, this.mulAcctRcptForm)
          const { data } = result
          var counter = 0
          if (data.data.length > 0) {
            data.data.map((mulAcctReceipt) => {
              const mulAcctReceiptList = {
                branch: mulAcctReceipt.branch,
                accountNo: mulAcctReceipt.accountNo,
                documentNo: mulAcctReceipt.documentNo,
                docAE: mulAcctReceipt.docAE,
                documentNoDisabled: mulAcctReceipt.documentNoDisabled,
                transactionType: mulAcctReceipt.transactionType,
                fund: mulAcctReceipt.fund,
                accountNoSuffix: mulAcctReceipt.accountNoSuffix,
                accountNoSuffixDesc: mulAcctReceipt.accountNoSuffix,
                transactionDate: mulAcctReceipt.transactionDate,
                transactionDateDisp: mulAcctReceipt.transactionDate,
                receivedFrom: mulAcctReceipt.accountNo,
                depositAcct: mulAcctReceipt.bankNo,
                bankNo: mulAcctReceipt.bankNo,
                paymentMethod: mulAcctReceipt.paymentMethod,
                cashBook: mulAcctReceipt.cashBook,
                gstIO: mulAcctReceipt.gstIO,
                gstStatus: mulAcctReceipt.gstStatus,
                gstRate: mulAcctReceipt.gstRate,
                currency: mulAcctReceipt.currency,
                amount: formatPrice(mulAcctReceipt.amount),
                gstAmount: formatPrice(mulAcctReceipt.gstAmount),
                gstAmountAE: mulAcctReceipt.gstAmountAE === 'true' ? 'A' : 'E',
                netAmount: formatPrice(mulAcctReceipt.netAmount),
                bankAmount: formatPrice(mulAcctReceipt.bankAmount),
                bankAmountAE: mulAcctReceipt.bankAmountAE === 'true' ? 'A' : 'E',
                bankCharges: formatPrice(mulAcctReceipt.bankCharges),
                bankTotalAmount: formatPrice(Number(removeFormatNumber(mulAcctReceipt.bankAmount)) - Number(removeFormatNumber(mulAcctReceipt.bankCharges))),
                bankTotalLocal: formatPrice(mulAcctReceipt.bankTotalLocal),
                bankTotalLocalAE: mulAcctReceipt.bankTotalLocalAE === 'true' ? 'A' : 'E',
                amountCurr: mulAcctReceipt.amountCurr,
                gstAmountCurr: mulAcctReceipt.gstAmountCurr,
                netAmountCurr: mulAcctReceipt.netAmountCurr,
                bankAmountCurr: mulAcctReceipt.bankAmountCurr,
                bankChargesCurr: mulAcctReceipt.bankChargesCurr,
                bankTotalAmountCurr: mulAcctReceipt.bankTotalAmountCurr,
                bankTotalLocalCurr: mulAcctReceipt.bankTotalLocalCurr,
                printDocument: mulAcctReceipt.printDocument,
                addressTo: mulAcctReceipt.addressTo,
                policyNo: mulAcctReceipt.polNo !== null ? mulAcctReceipt.polNo + '-' + mulAcctReceipt.renCnt + '-' + mulAcctReceipt.endtCnt : '',
                insdRefNo: mulAcctReceipt.insdRefNo,
                companyName: mulAcctReceipt.companyName,
                docAddress1: mulAcctReceipt.docAddress1,
                docAddress2: mulAcctReceipt.docAddress2,
                docAddress3: mulAcctReceipt.docAddress3,
                docAddress4: mulAcctReceipt.docAddress4,
                postalCode: mulAcctReceipt.postalCode,
                details: mulAcctReceipt.details,
                statementRef: mulAcctReceipt.statementRef,
                department: mulAcctReceipt.department,
                insuredName: mulAcctReceipt.insuredName,
                claimNo: mulAcctReceipt.claimNo,
                gstRegNo: mulAcctReceipt.gstRegNo,
                taxInvoiceNo: mulAcctReceipt.taxInvoiceNo,
                payerBank: mulAcctReceipt.payerBank,
                payersChequeNo: mulAcctReceipt.payersChequeNo,
                drawerName: mulAcctReceipt.drawerName,
                creditCardNo: mulAcctReceipt.creditCardNo,
                amountCurrRate: mulAcctReceipt.amountCurrRate,
                bankAmountCurrRate: mulAcctReceipt.bankAmountCurrRate,
                actionName: mulAcctReceipt.actionName,
                bankTotalLocalCurrRate: mulAcctReceipt.bankTotalLocalCurrRate,
                saveStatus: 'false',
                createdBy: mulAcctReceipt.createdBy,
                createdDate: formatDisplayDateTime4(mulAcctReceipt.createdDate),
                modifiedBy: mulAcctReceipt.modifiedBy,
                modifiedDate: formatDisplayDateTime4(mulAcctReceipt.modifiedDate)
              }
              this.accountList.push(mulAcctReceiptList)
              counter = counter + 1

              if (counter === 1 && this.receiptData.tranMode !== 'Q') {
                this.defaultForm.branch = mulAcctReceipt.branch
                this.defaultForm.documentNo = mulAcctReceipt.documentNo
                this.defaultForm.transactionType = mulAcctReceipt.transactionType
                this.defaultForm.docAE = mulAcctReceipt.docAE === 'true'
                this.defaultForm.transactionDateDisp = mulAcctReceipt.transactionDate
                this.defaultForm.paymentMethod = mulAcctReceipt.paymentMethod
                this.defaultForm.payerBank = mulAcctReceipt.payerBank
                this.defaultForm.payersChequeNo = mulAcctReceipt.payersChequeNo
                this.defaultForm.drawerName = mulAcctReceipt.drawerName
                this.defaultForm.creditCardNo = mulAcctReceipt.creditCardNo
                this.defaultForm.depositAcct = mulAcctReceipt.bankNo
                this.defaultForm.fund = mulAcctReceipt.fund
                this.defaultForm.gstIO = mulAcctReceipt.gstIO
                this.defaultForm.gstStatus = mulAcctReceipt.gstStatus
                this.defaultForm.gstRate = mulAcctReceipt.gstRate
                this.defaultForm.amountCurr = mulAcctReceipt.amountCurr
                this.defaultForm.bankAmountCurr = mulAcctReceipt.bankAmountCurr
                this.defaultForm.bankAmountCurrRate = mulAcctReceipt.amountCurrRate
                this.defaultForm.bankChargesCurr = mulAcctReceipt.bankChargesCurr
                this.defaultForm.bankTotalAmountCurr = mulAcctReceipt.bankTotalAmountCurr
                this.defaultForm.bankTotalLocalCurr = mulAcctReceipt.bankTotalLocalCurr
                this.defaultForm.printDocument = mulAcctReceipt.printDocument
                this.defaultForm.amountCurrRate = mulAcctReceipt.amountCurrRate
                this.initDisabled = true
                this.doReview(mulAcctReceiptList)
              } else if (counter === 1 && this.receiptData.tranMode === 'Q') {
                this.doQuery(mulAcctReceiptList)
              }
            })
            this.doAccumulate()
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async performSaveMultAcctRcpt() {
      const apiURI = this.$store.state.receipt.menu.performActionMultiAcct
      if (apiURI) {
        try {
          let messageFilters = clone(this.mulAcctRcptForm)
          for (var i = 0; i < messageFilters.accountList.length; i++) {
            if (messageFilters.accountList[i].transactionDate !== '') {
              messageFilters.accountList[i].transactionDate = formatDisplayDate(messageFilters.accountList[i].transactionDate)
            }
          }
          const result = await this.$http.post(apiURI, messageFilters)
          const { data } = result
          if (data) {
            if (messageFilters.actionName === 'CREATE_SAVE_POST' || messageFilters.actionName === 'UPDATE_SAVE_POST') {
              for (var ii = 0; ii < messageFilters.accountList.length; ii++) {
                if (messageFilters.accountList[ii].printDocument === 'I') {
                  const commit = {
                    branch: messageFilters.accountList[ii].branch,
                    accountNo: messageFilters.accountList[ii].accountNo,
                    type: messageFilters.accountList[ii].transactionType,
                    documentNo: data.resultMap.documentNo,
                    fund: messageFilters.accountList[ii].fund,
                    suffix: messageFilters.accountList[ii].accountNoSuffix,
                    actionName: messageFilters.actionName,
                    printDoc: messageFilters.printDocument
                  }
                  this.doExportAcctDoc(commit)
                }
              }
            }
            // // AR: OS-660 Unlock Record upon exit 29-Jan-2021
            let recKey = 'MUL|' + this.mulAcctRcptForm.transactionType + '|' +
                        this.mulAcctRcptForm.branch + '|' +
                        this.mulAcctRcptForm.documentNo + '|' +
                        this.mulAcctRcptForm.fund
            this.unlockRecord(recKey, 'ACT')
            this.doExit()
            this.notify(data)
            this.$router.push({ name: 'mulAcctReceipt' })
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async delMultAcctRcpt(data) {
      const apiUrl = this.$store.state.receipt.menu.delMultAcctRcpt
      try {
        const requestParams = data
        if (apiUrl) {
          this.$http.post(apiUrl, requestParams).then(result => {
            const data = result.data
            this.notify(data)
            this.doClearFilters()
          }).catch(err => {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          })
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    async fetchBranch() {
      this.branches = []
      let apiUrl = this.$store.state.receipt.menu.fetchBranch
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.branches.push(data)
              })
            }
          }
        })
      }
    },
    async fetchFund() {
      this.funds = []
      let apiUrl = this.$store.state.receipt.menu.fetchFund
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.funds.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAcctNoSfx() {
      this.acctnosuffixes = []
      let apiUrl = this.$store.state.receipt.menu.fetchAcctNoSfx
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.acctnosuffixes.push(data)
              })
            }
          }
        })
      }
    },
    async fetchGstStatus() {
      this.gstStatuses = []
      let apiUrl = this.$store.state.receipt.menu.fetchGstStatus
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.gstStatuses.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCurrency() {
      this.currencies = []
      let apiUrl = this.$store.state.receipt.menu.fetchCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.currencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAmountCurrency() {
      this.amountcurrencies = []
      let apiUrl = this.$store.state.receipt.menu.fetchAmountCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.amountcurrencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchPaymentMethod() {
      this.paymentmethods = []
      let apiUrl = this.$store.state.receipt.menu.fetchPaymentMethod
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.paymentmethods.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAccount() {
      this.accounts = []
      let apiUrl = this.$store.state.receipt.menu.fetchAccount
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.accounts.push(data)
              })
            }
          }
        })
      }
    },
    async fetchDepartment() {
      this.departments = []
      let apiUrl = this.$store.state.receipt.menu.fetchDepartment
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.departments.push(data)
              })
            }
          }
        })
      }
    },
    async fetchBank() {
      this.banks = []
      let apiUrl = this.$store.state.receipt.menu.fetchBank
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.banks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCashBook() {
      this.cashbooks = []
      let apiUrl = this.$store.state.receipt.menu.fetchCashBook
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.cashbooks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchPayerBank() {
      this.payerbanks = []
      let apiUrl = this.$store.state.receipt.menu.fetchPayerBank
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.payerbanks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchUserDetails(userid) {
      let username = '-'
      let apiUrl = this.$store.state.receipt.menu.fetchUserDetails
      if (apiUrl) {
        const expand = {
          userId: userid
        }
        await this.$http.get(expandURI(apiUrl, expand)).then(result => {
          if (result.data) {
            const data = result.data.dataMap
            const { userDetails } = data
            username = userDetails.firstName
            if (userDetails.lastName !== null || userDetails.lastName !== '') {
              username = username + ' ' + userDetails.lastName
            }
          }
        })
      }
      return username
    }
  },
  computed: {
    mulAcctRcptMenu() {
      return this.$store.state.receipt.menu
    }
  },
  mixins: [
    MessageMixin,
    recordLockMixin
  ]
}
